export const ACCOUNT_ACTIVATED = 'Sign Up - Account activated';
export const ACCOUNT_CREATED = 'Sign Up';
export const ACCOUNT_CREATION_FAILED = 'Sign Up - Failed';

export const LOGOUT = 'User Logged Out';
export const EXIT = 'Exited To Product';
export const LOGIN_SUCCESS = 'Login Success';
